import Conflict from "../../entities/conflict";

/**
 * Conflict actions
 *
 * Call order:
 *
 * CONFLICT_SAVE_QUEUE:	adds the item to the save queue
 * --> CONFLICT_SAVE:	modifies the state
 * --> CONFLICT_SAVE_SUCCESS: if all went well
 * --> CONFLICT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail CONFLICT_SAVE_QUEUE is during the call to CONFLICT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const CONFLICT_FETCH_ONE_QUEUE: any = 'CONFLICT_FETCH_ONE_QUEUE';
export const CONFLICT_FETCH_SUCCESS: any = 'CONFLICT_FETCH_SUCCESS';
export const CONFLICT_FETCH_FAILURE: any = 'CONFLICT_FETCH_FAILURE';
export const CONFLICT_FETCH_ONE_SUCCESS: any = 'CONFLICT_FETCH_ONE_SUCCESS';
export const CONFLICT_FETCH_ONE_FAILURE: any = 'CONFLICT_FETCH_ONE_FAILURE';

export const CONFLICT_SAVE: any = 'CONFLICT_SAVE';
export const CONFLICT_SAVE_QUEUE: any = 'CONFLICT_SAVE_QUEUE';
export const CONFLICT_SAVE_SUCCESS: any = 'CONFLICT_SAVE_SUCCESS';
export const CONFLICT_SAVE_FAILURE: any = 'CONFLICT_SAVE_FAILURE';

export const CONFLICT_SAVE_MANY: any = 'CONFLICT_SAVE_MANY';
export const CONFLICT_SAVE_MANY_QUEUE: any = 'CONFLICT_SAVE_MANY_QUEUE';
export const CONFLICT_SAVE_MANY_SUCCESS: any = 'CONFLICT_SAVE_MANY_SUCCESS';
export const CONFLICT_SAVE_MANY_FAILURE: any = 'CONFLICT_SAVE_MANY_FAILURE';

export const CONFLICT_REMOVE: any = 'CONFLICT_REMOVE';
export const CONFLICT_REMOVE_QUEUE: any = 'CONFLICT_REMOVE_QUEUE';
export const CONFLICT_REMOVE_SUCCESS: any = 'CONFLICT_REMOVE_SUCCESS';
export const CONFLICT_REMOVE_FAILURE: any = 'CONFLICT_REMOVE_FAILURE';

export const CONFLICT_RESTORE: any = 'CONFLICT_RESTORE';
export const CONFLICT_RESTORE_QUEUE: any = 'CONFLICT_RESTORE_QUEUE';
export const CONFLICT_RESTORE_SUCCESS: any = 'CONFLICT_RESTORE_SUCCESS';
export const CONFLICT_RESTORE_FAILURE: any = 'CONFLICT_RESTORE_FAILURE';

export const CONFLICT_RESTORE_MANY: any = 'CONFLICT_RESTORE_MANY';
export const CONFLICT_REMOVE_MANY: any = 'CONFLICT_REMOVE_MANY';

/* Fetch actions */
export const fetchConflictSuccess = (conflicts: Conflict[], partial: boolean, lastFetch: number) => ({type: CONFLICT_FETCH_SUCCESS, conflicts, partial, lastFetch});
export const fetchConflictFailure = (err: any) => {
		console.error('ConflictAction: fetchConflictFailure', err);
		return {type: CONFLICT_FETCH_FAILURE, err};
};
export const fetchOneConflictQueue = (conflictId: string) => ({type: CONFLICT_FETCH_ONE_QUEUE, conflictId});
export const fetchOneConflictSuccess = (conflict: Conflict) => ({type: CONFLICT_FETCH_ONE_SUCCESS, conflict});
export const fetchOneConflictFailure = (id: string, err: any) => {
		console.error('ConflictAction: fetchOneConflictFailure', err);
		return {type: CONFLICT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveConflict = (conflict: Conflict) => {
    // console.debug('⮂ CONFLICT_SAVE action', conflict?.id);
    return {type: CONFLICT_SAVE, conflict};
}
export const saveConflictQueue = (conflict: Conflict, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ CONFLICT_SAVE_QUEUE action', conflict?.id);
    return {type: CONFLICT_SAVE_QUEUE, conflict, onQueued};
}
export const saveConflictSuccess = (conflict: Conflict) => {
    // console.debug('⮂ CONFLICT_SAVE_SUCCESS action', conflict?.id);
    return {type: CONFLICT_SAVE_SUCCESS, conflict};
}
export const saveConflictFailure = (conflict: Conflict, status: number, message: string) => {
    console.warn(`⮂ CONFLICT_SAVE_FAILURE error saving conflict: HTTP ${status}: ${message}`, conflict?.id);
    return {type: CONFLICT_SAVE_FAILURE, conflict, status, message};
};

/* SaveMany actions */
export const saveManyConflicts = (conflicts: Conflict[]) => {
    // console.debug('⮂ CONFLICT_SAVE_MANY action', conflicts?.map(conflict => conflict?.id).join(','));
    return {type: CONFLICT_SAVE_MANY, conflicts};
}
export const saveManyConflictsQueue = (conflicts: Conflict[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ CONFLICT_SAVE_MANY_QUEUE action', conflicts?.map(conflict => conflict.id).join(','));
    return {type: CONFLICT_SAVE_MANY_QUEUE, conflicts, onQueued};
}

export const saveManyConflictsSuccess = (conflicts: Conflict[]) => {
    // console.debug('⮂ CONFLICT_SAVE_MANY_SUCCESS action', conflicts?.map(conflict => conflict.id).join(','));
    return {type: CONFLICT_SAVE_MANY_SUCCESS, conflicts};
}
export const saveManyConflictsFailure = (conflicts: Conflict[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_CONFLICTS_FAILURE Error saving conflicts: HTTP ${status}: ${message}`, conflicts?.map(conflict => conflict.id).join(','));
		return {type: CONFLICT_SAVE_MANY_FAILURE, conflicts, status, message};
};

/* Remove actions */
export const removeConflict = (conflict: Conflict) => ({ type: CONFLICT_REMOVE, conflict });
export const removeConflictQueue = (conflict: Conflict) => ({ type: CONFLICT_REMOVE_QUEUE, conflict });
export const removeConflictSuccess = (conflict: Conflict) => ({ type: CONFLICT_REMOVE_SUCCESS, conflict });
export const removeConflictFailure = (conflict: Conflict, status: number, message: string) => {
	console.error(`Redux: removeConflictFailure Error removing conflict: HTTP ${status}: ${message}`);
	return ({ type: CONFLICT_REMOVE_FAILURE, conflict, status, message });
};

/* Restore actions */
export const restoreConflict = (conflict: Conflict) => ({ type: CONFLICT_RESTORE, conflict });
export const restoreConflictQueue = (conflict: Conflict) => ({ type: CONFLICT_RESTORE_QUEUE, conflict });
export const restoreConflictSuccess = (conflict: Conflict) => ({ type: CONFLICT_RESTORE_SUCCESS, conflict });
export const restoreConflictFailure = (conflict: Conflict, status: number, message: string) => {
	console.error(`Redux: restoreConflictFailure Error restoring conflict: HTTP ${status}: ${message}`);
	return ({ type: CONFLICT_RESTORE_FAILURE, conflict, status, message });
};

/* RestoreMany actions */
export const restoreManyConflicts = (conflicts: Conflict[]) => ({ type: CONFLICT_RESTORE_MANY, conflicts });

/* RemoveMany actions */
export const removeManyConflicts = (conflicts: Conflict[]) => ({ type: CONFLICT_REMOVE_MANY, conflicts });